module.exports = __webpack_public_path__ + "img/join3-1-h.06e4cb32.svg";